/**
 * Product-to-store mapping in session storage (multi-store carts).
 * Moved from features/product/utils/productStoreMap.ts — owns store routing logic.
 */
const PRODUCT_STORE_MAP_KEY = 'productStoreMap';

export const getProductStoreMap = (): Record<string, string> => {
  try {
    const map = sessionStorage.getItem(PRODUCT_STORE_MAP_KEY);
    return map ? JSON.parse(map) : {};
  } catch (err) {
    console.error('Failed to parse product store map:', err);
    return {};
  }
};

export const setProductStoreMapping = (productId: string, storeKey: string): void => {
  const map = getProductStoreMap();
  map[productId] = storeKey;
  sessionStorage.setItem(PRODUCT_STORE_MAP_KEY, JSON.stringify(map));
};

export const clearProductStoreMap = (): void => {
  sessionStorage.removeItem(PRODUCT_STORE_MAP_KEY);
};
